module.exports = __webpack_public_path__ + "img/banner.e6f7038e.jpg";